import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './CarrotPage.css';
import carrotLogo from '../images/carrot-logo.png';
import carrotDs505 from '../images/carrot-ds-505-img.png';

const varieties = [
 
  {
    name: 'DS-505 ',
    image: carrotDs505,
    description: [
      'Early Nantes type with blunt root end',
      'Plant habit: Early vigorous and high yielder with uniform long cylindrical roots',
      'Root characteristics: Smooth, deep orange roots with very small self-coloured core',
      'Flesh quality: Sweet and crisp with good storage and transport quality',
      'Root size: Cylindrical roots of about 15-20 cm length',
    ],
  },
];

export default function CarrotPage() {
  return <ProductPatternPage title="Carrot" varieties={varieties} pageClass="carrot-page" heroImage={carrotLogo} />;
}
